/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Trainer_Contact_DescriptionInputs */

const en_seo_trainer_contact_description = /** @type {(inputs: Seo_Trainer_Contact_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: phone, email, address and opening hours.`)
};

const pl_seo_trainer_contact_description = /** @type {(inputs: Seo_Trainer_Contact_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: telefon, e-mail, adres i godziny otwarcia.`)
};

/**
* | output |
* | --- |
* | "{name}: phone, email, address and opening hours." |
*
* @param {Seo_Trainer_Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_trainer_contact_description = /** @type {((inputs: Seo_Trainer_Contact_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Trainer_Contact_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_trainer_contact_description(inputs)
	return en_seo_trainer_contact_description(inputs)
});